import ChartMetric from '@/Enums/Chart/Metric.enum';
import InsightCallout from '@/components/InsightCallout';
import { getVerticalFootTrafficGraphData } from '@/helpers/attribution/chartData';
import { selectFootTrafficPeakHourInsight } from '@/helpers/attribution/footTrafficInsights';
import { downloadCSV } from '@/helpers/downloadCSV';
import { useAppSelector } from '@/store/hooks';
import { selectFootTrafficHourOfDayReport } from '@/store/selectors/attribution/footTraffic.selectors';
import { useCallback, useMemo } from 'react';
import VerticalChart from '../Charts/VerticalChart';
import GraphCard from './BaseCard/GraphCard';

const label = 'Hour of Day (Average Visits Per Day)';

const HourOfDayCard = () => {
  const { loading, hourReport } = useAppSelector(selectFootTrafficHourOfDayReport);
  const { text: insightText } = useAppSelector(selectFootTrafficPeakHourInsight);

  const { chartData, csvData } = useMemo(
    () => getVerticalFootTrafficGraphData(hourReport, loading),
    [hourReport, loading],
  );

  const noData = useMemo<boolean>(() => Object.values(hourReport).every(visits => !visits), [hourReport]);

  const onDownload = useCallback(() => {
    if (!loading) {
      downloadCSV(csvData, label);
    }
  }, [csvData, loading]);

  return (
    <GraphCard label={label} loading={loading} noData={noData} onDownload={onDownload} allowPrint>
      <VerticalChart chartData={chartData} legendLabel={ChartMetric.FootTrafficVisits} />
      <InsightCallout text={insightText} loading={loading} />
    </GraphCard>
  );
};

export default HourOfDayCard;
